export enum RideViewType {
    TODAYS = 'TODAYS',
    LIST = 'LIST',
    DETAILS = 'DETAILS'
}
export enum ZonesViewType {
    POI = 'POI',
    AOI = 'AOI'
}
export enum CarDetailsViewType {
    CAR_DETAILS = 'CAR_DETAILS',
    HISTORY_RIDES = 'HISTORY_RIDES',
    ALERTS = 'ALERTS'
}
export enum TimeDisplayFormat {
    DESCRIPTIVE = 'DESCRIPTIVE',
    NUMERIC = 'NUMERIC'
}



// WEBPACK FOOTER //
// ./src/Models/EnumTypes/HistoryEnumTypes.ts